import { render, staticRenderFns } from "./RollDiceMessage.vue?vue&type=template&id=517064e2&scoped=true"
import script from "./RollDiceMessage.vue?vue&type=script&lang=js"
export * from "./RollDiceMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517064e2",
  null
  
)

export default component.exports